module.exports = __webpack_public_path__ + "media/registration/webinars@1x-286a2433.png";